///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// Autogenerated on 02.07.2015 10:25:10
//
// Requires jQuery
//
// If there are multiple versions of a method, please remove all but the one you need
// since javascript only supports one method per method name (the last version will overwrite the previous versions).
//
// Usage:
// 1) Instantiate the api:
//
//    var api = new Capitech.Api.WebtidApi("https://server.location.com/");
//
//
// 2) Call the methods.
//    The first and second parameteres is jQuery.ajax's 'success' and 'error'-methods, see http://api.jquery.com/jquery.ajax/
//    The other parameters are the parameters defined by the api.
//
//    api.methodName(function(data, status, xhr) { console.log(data, status, xhr); }, function(data) { console.log(data); }, parameterA, parameterB, etc);
//
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

(function(_parent, _jQuery) {
    
    namespace("Capitech.Api");
    var self = Capitech.Api.WebtidApi = function(applicationRootPath) {
        this.applicationRootPath = applicationRootPath;
        return this;
    };

    self.prototype.authorize_POST = function(successFunc, errorFunc, clientId, username, password) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/authorize", uriParameterData);
        var method = "POST";
        var parameterData = { "clientId": clientId, "username": username, "password": password };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }

    self.prototype.changeClient_POST = function(successFunc, errorFunc, refreshToken, clientId) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/changeClient", uriParameterData);
        var method = "POST";
        var parameterData = { "refreshToken": refreshToken, "clientId": clientId };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getAuthorizedCapitechClients_POST = function(successFunc, errorFunc, refreshToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getAuthorizedCapitechClients", uriParameterData);
        var method = "POST";
        var parameterData = { "refreshToken": refreshToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getAvaliableCapitechClients_POST = function(successFunc, errorFunc) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getAvaliableCapitechClients", uriParameterData);
        var method = "POST";
        var parameterData = {  };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getServerVersion_GET = function(successFunc, errorFunc) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getServerVersion", uriParameterData);
        var method = "GET";
        var parameterData = {  };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }

    self.prototype.getSettings_GET = function(successFunc, errorFunc) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getSettings", uriParameterData);
        var method = "GET";
        var parameterData = {  };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.isClientApplicationVersionSupported_POST = function(successFunc, errorFunc, clientIdentifier, version) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/isClientApplicationVersionSupported", uriParameterData);
        var method = "POST";
        var parameterData = { "clientIdentifier": clientIdentifier, "version": version };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.refreshAuthorization_POST = function(successFunc, errorFunc, refreshToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/refreshAuthorization", uriParameterData);
        var method = "POST";
        var parameterData = { "refreshToken": refreshToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }

    self.prototype.signOut_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/signOut", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.createAbsenceRequest_POST = function(successFunc, errorFunc, accessToken, absenceCode, isShortTermAbsence, fromDate, fromTime, toDate, toTime, text) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/createAbsenceRequest", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "absenceCode": absenceCode, "isShortTermAbsence": isShortTermAbsence, "fromDate": fromDate, "fromTime": fromTime, "toDate": toDate, "toTime": toTime, "text": text };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.deleteAbsenceRequest_POST = function(successFunc, errorFunc, accessToken, absenceRequestId) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/deleteAbsenceRequest", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "absenceRequestId": absenceRequestId };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getAbsenceCodes_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getAbsenceCodes", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getAbsenceRequests_POST = function(successFunc, errorFunc, accessToken, startDate) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getAbsenceRequests", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "startDate": startDate };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getAbsenceTransactions_POST = function(successFunc, errorFunc, accessToken, fromDate, toDate) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getAbsenceTransactions", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "fromDate": fromDate, "toDate": toDate };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
	
	
	
    self.prototype.acknowledgeMessage_POST = function(successFunc, errorFunc, DialogId, MessageId, AccessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/acknowledgeMessage", uriParameterData);
        var method = "POST";
        var parameterData = { "DialogId": DialogId, "MessageId": MessageId, "AccessToken": AccessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.confirmMessage_POST = function(successFunc, errorFunc, DialogId, MessageId, AccessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/confirmMessage", uriParameterData);
        var method = "POST";
        var parameterData = { "DialogId": DialogId, "MessageId": MessageId, "AccessToken": AccessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getDialogMessages_POST = function(successFunc, errorFunc, threadId, Take, Skip, AccessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getDialogMessages", uriParameterData);
        var method = "POST";
        var parameterData = { "threadId": threadId, "Take": Take, "Skip": Skip, "AccessToken": AccessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getDialogs_POST = function(successFunc, errorFunc, Take, Skip, AccessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getDialogs", uriParameterData);
        var method = "POST";
        var parameterData = { "Take": Take, "Skip": Skip, "AccessToken": AccessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.sendInDialog_POST = function(successFunc, errorFunc, DialogId, MessageBody, AccessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/sendInDialog", uriParameterData);
        var method = "POST";
        var parameterData = { "DialogId": DialogId, "MessageBody": MessageBody, "AccessToken": AccessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.startDialog_POST = function(successFunc, errorFunc, ReceivingDepartmentId, Subject, Body, AccessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/startDialog", uriParameterData);
        var method = "POST";
        var parameterData = { "ReceivingDepartmentId": ReceivingDepartmentId, "Subject": Subject, "Body": Body, "AccessToken": AccessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }

    self.prototype.getCompetenceroleDescriptions_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getCompetenceroleDescriptions", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getDepartmentDescriptions_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getDepartmentDescriptions", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getDimensionNames_POST = function(successFunc, errorFunc, accessToken, cultureCode) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getDimensionNames", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "cultureCode": cultureCode };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }

    self.prototype.getDutyDefinitionDescriptions_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getDutyDefinitionDescriptions", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getDutyDescriptions_POST = function(successFunc, errorFunc, accessToken, departmentId) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getDutyDescriptions", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "departmentId": departmentId };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getFridim1Descriptions_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getFridim1Descriptions", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getFridim2Descriptions_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getFridim2Descriptions", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getHolidays_POST = function(successFunc, errorFunc, accessToken, fromDate, toDate) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getHolidays", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "fromDate": fromDate, "toDate": toDate };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getOrderDescriptions_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getOrderDescriptions", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getPhaseDescriptions_POST = function(successFunc, errorFunc, accessToken, projectId, subProjectId) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getPhaseDescriptions", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "projectId": projectId, "subProjectId": subProjectId };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getProjectDescriptions_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getProjectDescriptions", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getShiftDescriptions_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getShiftDescriptions", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getSubProjectDescriptions_POST = function(successFunc, errorFunc, accessToken, projectId) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getSubProjectDescriptions", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "projectId": projectId };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getTaskDescriptions_POST = function(successFunc, errorFunc, accessToken, departmentId) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getTaskDescriptions", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "departmentId": departmentId };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.cancelRequestForAvaliableDuty_POST = function(successFunc, errorFunc, accessToken, departmentId, dutyPlanId, dutyId, fromDate) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/cancelRequestForAvaliableDuty", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "departmentId": departmentId, "dutyPlanId": dutyPlanId, "dutyId": dutyId, "fromDate": fromDate };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.createDutyWish_POST = function(successFunc, errorFunc, accessToken, date, requestedDepartmentIds, requestedDutyTypeIds, commentFromEmployee, isEmployeeAvaliableOnShortNotice) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/createDutyWish", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "date": date, "requestedDepartmentIds": requestedDepartmentIds, "requestedDutyTypeIds": requestedDutyTypeIds, "commentFromEmployee": commentFromEmployee, "isEmployeeAvaliableOnShortNotice": isEmployeeAvaliableOnShortNotice };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.createDutyWishPeriod_POST = function(successFunc, errorFunc, accessToken, fromDate, toDate, requestedDaysOfWeek, requestedDepartmentIds, requestedDutyTypeIds, commentFromEmployee, isEmployeeAvaliableOnShortNotice) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/createDutyWishPeriod", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "fromDate": fromDate, "toDate": toDate, "requestedDaysOfWeek": requestedDaysOfWeek, "requestedDepartmentIds": requestedDepartmentIds, "requestedDutyTypeIds": requestedDutyTypeIds, "commentFromEmployee": commentFromEmployee, "isEmployeeAvaliableOnShortNotice": isEmployeeAvaliableOnShortNotice };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.deleteDutyWish_POST = function(successFunc, errorFunc, accessToken, date) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/deleteDutyWish", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "date": date };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.deleteDutyWishPeriod_POST = function(successFunc, errorFunc, accessToken, originalFromDate) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/deleteDutyWishPeriod", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "originalFromDate": originalFromDate };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getAvaliableDuties_POST = function(successFunc, errorFunc, accessToken, fromDate, toDate) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getAvaliableDuties", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "fromDate": fromDate, "toDate": toDate };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getDutyWish_POST = function(successFunc, errorFunc, accessToken, fromDate, toDate) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getDutyWish", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "fromDate": fromDate, "toDate": toDate };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getDutyWishFilter_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getDutyWishFilter", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getDutyWishPeriod_POST = function(successFunc, errorFunc, accessToken, fromDate) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getDutyWishPeriod", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "fromDate": fromDate };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getDutyWishPeriods_POST = function(successFunc, errorFunc, accessToken, fromDate, toDate) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getDutyWishPeriods", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "fromDate": fromDate, "toDate": toDate };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getPlannedDutiesForEmployee_POST = function(successFunc, errorFunc, accessToken, fromDate, toDate) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getPlannedDutiesForEmployee", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "fromDate": fromDate, "toDate": toDate };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getPossibleValuesForDutyWishFilter_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getPossibleValuesForDutyWishFilter", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getRequestedDuties_POST = function(successFunc, errorFunc, accessToken, fromDate, toDate) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getRequestedDuties", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "fromDate": fromDate, "toDate": toDate };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.requestAvaliableDuty_POST = function(successFunc, errorFunc, accessToken, departmentId, dutyPlanId, dutyId, originalEmployeeId, originalFromDate, commentFromEmployee) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/requestAvaliableDuty", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "departmentId": departmentId, "dutyPlanId": dutyPlanId, "dutyId": dutyId, "originalEmployeeId": originalEmployeeId, "originalFromDate": originalFromDate, "commentFromEmployee": commentFromEmployee };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.saveDutyWishFilter_POST = function(successFunc, errorFunc, accessToken, departmentIds, dutyTypeIds, displayAvaliableDutiesOnDaysIAlreadyHaveOtherDuties) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/saveDutyWishFilter", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "departmentIds": departmentIds, "dutyTypeIds": dutyTypeIds, "displayAvaliableDutiesOnDaysIAlreadyHaveOtherDuties": displayAvaliableDutiesOnDaysIAlreadyHaveOtherDuties };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.updateDutyWishPeriod_POST = function(successFunc, errorFunc, accessToken, originalFromDate, newFromDate, newToDate, requestedDaysOfWeek, requestedDepartmentIds, requestedDutyTypeIds, newCommentFromEmployee, isEmployeeAvaliableOnShortNotice) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/updateDutyWishPeriod", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "originalFromDate": originalFromDate, "newFromDate": newFromDate, "newToDate": newToDate, "requestedDaysOfWeek": requestedDaysOfWeek, "requestedDepartmentIds": requestedDepartmentIds, "requestedDutyTypeIds": requestedDutyTypeIds, "newCommentFromEmployee": newCommentFromEmployee, "isEmployeeAvaliableOnShortNotice": isEmployeeAvaliableOnShortNotice };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getFlexiTimeBalance_POST = function(successFunc, errorFunc, accessToken, year) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getFlexiTimeBalance", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "year": year };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getFlexiTimeTransactions_POST = function(successFunc, errorFunc, accessToken, year) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getFlexiTimeTransactions", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "year": year };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getAllLocalizations_POST = function(successFunc, errorFunc, cultureCode, clientId) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getAllLocalizations", uriParameterData);
        var method = "POST";
        var parameterData = { "cultureCode": cultureCode, "clientId": clientId };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getHelpHtml_POST = function(successFunc, errorFunc, cultureCode) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getHelpHtml", uriParameterData);
        var method = "POST";
        var parameterData = { "cultureCode": cultureCode };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getSingleLocalization_POST = function(successFunc, errorFunc, cultureCode, resourceKey, clientId) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getSingleLocalization", uriParameterData);
        var method = "POST";
        var parameterData = { "cultureCode": cultureCode, "resourceKey": resourceKey, "clientId": clientId };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getTimeCategoryForManualAddition_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getTimeCategoryForManualAddition", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.updateManualAddition_POST = function(successFunc, errorFunc, accessToken, inDate, inTime, details) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/updateManualAddition", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "inDate": inDate, "inTime": inTime, "details": details };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.createMessage_POST = function(successFunc, errorFunc, accessToken, message) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/createMessage", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "message": message };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.deleteMessage_POST = function(successFunc, errorFunc, accessToken, messageId) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/deleteMessage", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "messageId": messageId };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getIncomingMessages_POST = function(successFunc, errorFunc, accessToken, includePendingMessages, numberOfDaysBackInTimeToIncludeAcknowledgedMessages) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getIncomingMessages", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "includePendingMessages": includePendingMessages, "numberOfDaysBackInTimeToIncludeAcknowledgedMessages": numberOfDaysBackInTimeToIncludeAcknowledgedMessages };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getNumberOfPendingIncomingMessages_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getNumberOfPendingIncomingMessages", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getOutgoingMessages_POST = function(successFunc, errorFunc, accessToken, numberOfDaysBackInTimeToInclude) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getOutgoingMessages", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "numberOfDaysBackInTimeToInclude": numberOfDaysBackInTimeToInclude };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.markMessageAsAcknowledged_POST = function(successFunc, errorFunc, accessToken, messageId) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/markMessageAsAcknowledged", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "messageId": messageId };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }

    self.prototype.getMyCapitechSettings_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getMyCapitechSettings", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.upsertMyCapitechSetting_POST = function(successFunc, errorFunc, accessToken, key, value) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/upsertMyCapitechSetting", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "key": key, "value": value };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }

    self.prototype.getExternalLinks_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getExternalLinks", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getAvaliableReports_POST = function(successFunc, errorFunc, accessToken, cultureCode) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getAvaliableReports", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "cultureCode": cultureCode };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getReport_POST = function(successFunc, errorFunc, accessToken, cultureCode, reportId, fromDate, toDate) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getReport", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "cultureCode": cultureCode, "reportId": reportId, "fromDate": fromDate, "toDate": toDate };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.createCustomTimeTransaction_POST = function(successFunc, errorFunc, accessToken, dateIn, timeIn, dateOut, timeOut, departmentId, taskId, orderId, projectId, subProjectId, phaseId, dutyId, competenceRoleId, dutyDefinitionId, shiftId, fridim1Id, fridim2Id, text) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/createCustomTimeTransaction", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "dateIn": dateIn, "timeIn": timeIn, "dateOut": dateOut, "timeOut": timeOut, "departmentId": departmentId, "taskId": taskId, "orderId": orderId, "projectId": projectId, "subProjectId": subProjectId, "phaseId": phaseId, "dutyId": dutyId, "competenceRoleId": competenceRoleId, "dutyDefinitionId": dutyDefinitionId, "shiftId": shiftId, "fridim1Id": fridim1Id, "fridim2Id": fridim2Id, "text": text };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.createDefaultTimeTransactionIn_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/createDefaultTimeTransactionIn", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.createTimeTransactionOut_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/createTimeTransactionOut", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.deleteTimeTransaction_POST = function(successFunc, errorFunc, accessToken, existingDateIn, existingTimeIn) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/deleteTimeTransaction", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "existingDateIn": existingDateIn, "existingTimeIn": existingTimeIn };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getAccumulatedTime_POST = function(successFunc, errorFunc, accessToken, fromDate, toDate) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getAccumulatedTime", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "fromDate": fromDate, "toDate": toDate };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getAccumulatedTimeForSingleTransaction_POST = function(successFunc, errorFunc, accessToken, inDate, inTime) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getAccumulatedTimeForSingleTransaction", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "inDate": inDate, "inTime": inTime };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getEmployeeRegistrationInformation_POST = function(successFunc, errorFunc, accessToken, capitechPlanDutyDate) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getEmployeeRegistrationInformation", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "capitechPlanDutyDate": capitechPlanDutyDate };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getTimeTransactionDetails_POST = function(successFunc, errorFunc, accessToken, fromDate, toDate) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getTimeTransactionDetails", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "fromDate": fromDate, "toDate": toDate };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getTimeTransactions_POST = function(successFunc, errorFunc, accessToken, fromDate, toDate) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getTimeTransactions", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "fromDate": fromDate, "toDate": toDate };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.updateTimeTransaction_POST = function(successFunc, errorFunc, accessToken, existingDateIn, existingTimeIn, newDateIn, newTimeIn, newDateOut, newTimeOut, newDepartmentId, newTaskId, newOrderId, newProjectId, newSubProjectId, newPhaseId, newDutyId, newCompetenceRoleId, newDutyDefinitionId, newShiftId, newFridim1Id, newFridim2Id, newText) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/updateTimeTransaction", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "existingDateIn": existingDateIn, "existingTimeIn": existingTimeIn, "newDateIn": newDateIn, "newTimeIn": newTimeIn, "newDateOut": newDateOut, "newTimeOut": newTimeOut, "newDepartmentId": newDepartmentId, "newTaskId": newTaskId, "newOrderId": newOrderId, "newProjectId": newProjectId, "newSubProjectId": newSubProjectId, "newPhaseId": newPhaseId, "newDutyId": newDutyId, "newCompetenceRoleId": newCompetenceRoleId, "newDutyDefinitionId": newDutyDefinitionId, "newShiftId": newShiftId, "newFridim1Id": newFridim1Id, "newFridim2Id": newFridim2Id, "newText": newText };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.changePassword_POST = function(successFunc, errorFunc, accessToken, oldPassword, newPassword, newPasswordRepeated) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/changePassword", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken, "oldPassword": oldPassword, "newPassword": newPassword, "newPasswordRepeated": newPasswordRepeated };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }

    self.prototype.forgotPassword_POST = function(successFunc, errorFunc, clientId, emailAddress, cultureCode) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/forgotPassword", uriParameterData);
        var method = "POST";
        var parameterData = { "clientId": clientId, "emailAddress": emailAddress, "cultureCode": cultureCode };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getEmployeePersonalInformation_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getEmployeePersonalInformation", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getPostalTownFromNorwegianZipCode_POST = function(successFunc, errorFunc, norwegianZipCode) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getPostalTownFromNorwegianZipCode", uriParameterData);
        var method = "POST";
        var parameterData = { "norwegianZipCode": norwegianZipCode };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getVacationBalance_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getVacationBalance", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype.getVacationTransactions_POST = function(successFunc, errorFunc, accessToken) {
        var uriParameterData = {  };
        var url = this._getUrl("api/public/v1/Webtid/getVacationTransactions", uriParameterData);
        var method = "POST";
        var parameterData = { "accessToken": accessToken };
        this._call(url, method, parameterData, successFunc, errorFunc);
    }
    
    self.prototype._getUrl = function(methodRelativePath, uriParameters) {
        var url = this.applicationRootPath + methodRelativePath;
        for (var uriParameter in uriParameters) {
            var regex = new RegExp(uriParameter, "g");
            url = url.replace(regex, uriParameters[uriParameter]);
        }
        return url;
    };

    self.prototype._call = function(url, method, parameterData, success, error) {
        _jQuery.ajax({
            url: url,
            type: method,
            data: method == "GET" ? null : parameterData,
            dataType: 'json',
            success: success,
            error: error
        });
    };

    function namespace(namespaceString) {
        if (!namespaceString
            || typeof namespaceString !== "string"
            || arguments.length != 1) throw "Argument 'namespaceString' must be a string";

        var currentSection = _parent;
        var namespaceParts = namespaceString.split(".");

        for (var i = 0; i < namespaceParts.length; ++i) {
            var namespacePart = namespaceParts[i];

            if (!currentSection[namespacePart]) {
                currentSection[namespacePart] = {};
            }

            currentSection = currentSection[namespacePart];
        }
        return currentSection;
    };

}(window, jQuery));